import React, { Component } from "react";
// Layouts
import Accordion from "../UI/Accordion/Accordion";
import Loader from "../UI/Loading/Loading";
import { Dropdown, DropdownDivider, DropdownItem, DropdownMenu, Radio  } from "semantic-ui-react";
import Icon from "../UI/Icon/Icon";
import { Requests } from "../../api/IdentityServerRequests/Requests";
import { getAgencyQualifications } from "../../utils/SharedUtils";
import Button from '../UI/Button/Button';
// Data
import copy from "../../assets/copy/copy.json";
// styles
import styles from "./QualificationFavouriteTile.module.scss";

export default class QualificationTile extends Component {
  constructor(props) {
    super(props);
    const userAgencies = props.userAgencies
    ?.filter((agency) => agency !== "AV" && agency !== "DYNAMIC")
      ?.map((agency) => ({
        key: agency,
        text: agency,
        value: agency,
      }));
    this.state = {
      userAgencies: userAgencies,
      selectedUserAgency: userAgencies?.length > 0 ? userAgencies[0].value : "",
      agencyQualifications: [],
      qualificationFavourites: [],
      finalisedFavouritesSave: [],
      isSaveCompleted: false,
    };
    this.Requests = new Requests();
  }
  handleAgencyChange = (event) => {
    this.setState({ selectedAgency: event,
                    isSaveCompleted: false
      });
  };
  getFavouriteQualifications = async () => {
    try {
      if (!this.Requests) {
        throw new Error('Requests object is not defined');
      }
      const data = await this.Requests.callAPI(
        this.Requests.getQualificationFavourites,
        this.state.selectedUserAgency
      );
      if (data?.status === 200 && data.data?.[0]?.qualifications) {
        return data.data[0].qualifications?.map((qual) => ({
          key: qual?.id,
          value: qual?.name,
        }));
      } else {
        console.warn('No qualifications found or invalid response');
        return [];
      }
    } catch (error) {
      console.error('Error fetching favourite qualifications:', error);
      return [];
    }
  };
  qualificationExpanded = async () => {
    try {
      await this.getAgencyQualificationFavourites();
    } catch (error) {
      console.error('Error in qualificationExpanded:', error);
    }
  }
  getAgencyQualificationFavourites = async () => {
    try {
      const agencyQualifications = await getAgencyQualifications(
        this.state.selectedUserAgency, this.Requests
      );
      const qualificationFavourites = await this.getFavouriteQualifications();
      this.setState({
        agencyQualifications,
        qualificationFavourites,
        finalisedFavouritesSave: qualificationFavourites,
        isSaveCompleted: false
      });
    } catch (error) {
      console.error("Error fetching agency qualifications or favourites:", error);
    }

  }
  qualificationPressed = (qual) => {
    if(this.state.qualificationFavourites.length < 10) {
      const newQualification = {
        key: qual.value, 
        value: qual.text,
      };
      // Update the state with unique qualifications
      this.setState((prevState) => {
        const updatedFavourites = [...prevState.qualificationFavourites];
        if (!updatedFavourites.some((item) => item.key === newQualification.key)) {
          updatedFavourites.push(newQualification);
        }
        return { qualificationFavourites: updatedFavourites,
                 isSaveCompleted: false };
      });
    }
    // Remove the qualification if it already exists in favourites
    if (
      this.state.qualificationFavourites.some(
        (item) => item.key === qual.value
      ) &&
      this.state.qualificationFavourites.length > 0
    ) {
      this.setState((prevState) => ({
        qualificationFavourites: prevState.qualificationFavourites.filter(
          (item) => item.key !== qual.value
        ),
      }));
    }
  };
  favouriteQualPressed = (qual) => {
    this.setState((prevState) => {
      const updatedFavourites = prevState.qualificationFavourites
        .filter((item) => item.key !== qual.key)
        .sort((a, b) => (a.value || "").localeCompare(b.value || ""));
  
      return {
        qualificationFavourites: updatedFavourites,
        finalisedFavouritesSave: updatedFavourites,
        isSaveCompleted: false,
      };
    });
  };
  saveFavourites = async () => {
    const sortedFavourites = [...this.state.qualificationFavourites].sort((a, b) =>
    a.value.localeCompare(b.value)
    );
    this.setState({
      finalisedFavouritesSave: sortedFavourites,
    }, async () => {
      const qualificationFavourites = this.state.finalisedFavouritesSave.map(item => Number(item.key));
      const payload = {
        agency: this.state.selectedUserAgency,
        qualificationFavourites: qualificationFavourites,
      };
      try {
        await this.Requests.callAPI(this.Requests.updateFavouriteQualifications, payload);
        this.setState({ isSaveCompleted: true }); // Update state after API call finishes
      } catch (error) {
        console.error("Error fetching agency qualifications:", error);
      }
    });
    
  }
  componentDidMount() {
    this.getAgencyQualificationFavourites();
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.selectedUserAgency !== null && prevState.selectedUserAgency !== this.state.selectedUserAgency) {
      this.getAgencyQualificationFavourites();
    }
  }
  render() {
    const favouriteIcon = <Icon icon="icon_settingsFavouriteQual"/>
    const unmaskedQualIcon = <Icon icon="icon_settingsUnmaskedQual"/>
    return (
      <div className="box_default">
        <Accordion
          ref={this.props.refProp}
          button={false}
          label="Close Qualification list"
          content={null}
          variant="btn_outline"
          styles="greenTxt"
          buttonClick={this.qualificationExpanded}>
          {(
            <div key="0001"
              label={copy.settings.profile.qualificationsFavouriteTitle}
              accordionContentStyle={styles.qualificationDropdown}>
              <div className={styles.dropdownContainer}>
                <div className={styles.groupedRow + " " + `dropDownClass`}>
                    <label htmlFor="userAgency">{copy.myAvailabilityScreen.myAvailability.addAvailabilityForm.userAgency}</label>
                    <Dropdown
                      compact
                      floating
                      defaultValue={this.state.selectedUserAgency}
                      text={this.state.selectedUserAgency}
                      placeholder={copy.myAvailabilityScreen.myAvailability.setAgency}
                      icon={<Icon icon="icon_arrowDownSmall" name="arrowIcon" />}
                      onChange={(e) => this.setState({ selectedUserAgency: e.target.value, isSaveCompleted: false })}
                    >
                      <DropdownMenu className="tileBg3">
                        {this.state.userAgencies?.map((agency, index) => {
                          return (
                            <DropdownItem key={agency.key || index} className={styles.listItem}
                            onClick={() => {
                              this.setState({ selectedUserAgency: agency.value });
                              this.handleAgencyChange(agency.value) }}>
                              {agency.text}
                            </DropdownItem>
                          )
                        })}
                      </DropdownMenu>
                    </Dropdown>
                </div>
              </div>
              {this.state.agencyQualifications.length > 0 && (
              <>
                <div className={styles.favouriteContainer}>
                  <span className={styles.favouriteTitle}>
                    Favourites {this.state.qualificationFavourites.length}/10
                  </span>
                  <p className={styles.favouriteSubTitle}>
                    Up to 10 qualifications can be selected as Favourites
                  </p>
                  <ul className={styles.favourListContainer}>
                    {this.state.finalisedFavouritesSave?.map((qual) => (
                      <li key={qual.key} className={styles.qualificationItem}>
                        <button className={styles.qualificationButton}
                              onClick={() => this.favouriteQualPressed(qual)}>
                        <span className={styles.favourIcon}>{favouriteIcon}</span>
                        <span className={styles.qualTitle}>{qual.value}</span>
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <p className={styles.qualificationsTitle}>All Qualifications</p>
                  <ul className={styles.listContainer}>
                    {this.state.agencyQualifications?.map((qual) => {
                      return (
                        <div
                          key={qual?.key}
                          className={styles.listItem + " " + styles.qualificationList}
                        >
                          <li key={qual?.value} className={styles.qualificationItem}>
                            <button
                              className={styles.qualificationButton}
                              onClick={() => this.qualificationPressed(qual)}
                            >
                              <span className={styles.favourIcon}>
                                {this.state.qualificationFavourites.some(
                                  (item) => item.key === qual.value
                                )
                                  ? favouriteIcon
                                  : unmaskedQualIcon}
                              </span>
                              <span className={styles.qualTitle}>{qual?.text}</span>
                            </button>
                          </li>
                        </div>
                      );
                    })}
                  </ul>
                </div>
                <div className={styles.row + " " + styles.spaceBetweenRow +" footerButtonContainer"}>
                    <Button
                      buttonClick={() => {
                        window.history.back();
                      }}
                      content="Back"
                      styles="greenTxt btn_outline"
                    >
                    </Button>
                    <Button
                      styles="greenTxt btn_outline"
                      buttonClick={this.saveFavourites}
                      content="Save"
                      > 
                    </Button>
                </div>
                {this.state.isSaveCompleted && (
                  <p className={styles.success + " fadeaway"}>
                    {copy.settings.profile.qualificationFavouriteSuccess}
                  </p>
                )}
              </>
              )}
            </div>
          )}
        </Accordion>
       
      </div>
        
    );
  }
}
